import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import { useConfig } from '../../config/ConfigContext';

let timerId;

export const Waiting = (props) => {
  const config = useConfig();
  const { fetch, navigate, checkinData } = props;
  const match = useParams();
  const params = parseUrlParams(window.location.search);
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    timerId = setInterval(() => {
      if (get(props.checkinData, ['data', 'url']).split('?')[0] === '/luwa/income/waiting'
        || get(props.checkinData, ['data', 'url']).split('?')[0] === `/${workflowType}/income/waiting`
      ) {
        props.newCheckInAction({
          workflowType,
          key: params.key,
          data: {
            checkStatus: true,
          },
        });
      } else {
        clearTimeout(timerId);
      }
    }, 5000);

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    }
  }, []);

  useEffect(() => {
    if (!get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl')) && fetch.isDone[`${NEW_CHECKIN}`] && !fetch.isRunning[`${NEW_CHECKIN}`]) {
      const url = get(checkinData, 'data.url', '');
      if (url.split('?')[0] !== '/luwa/income/waiting' && url.split('?')[0] !== `/${workflowType}/income/waiting`) {
        clearTimeout(timerId);
        let routeUrl = url.replace(config.hostUrl, '');
        if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
          routeUrl = addLusaHeaderParam(routeUrl);
        }
        navigate(routeUrl);
      }
    }
  }, [checkinData]);

  return (
    <div className="transition-item wrapper v-center">
      <div className="overlay-container">
        <h2 className="loading-message">Loading your account information. Please wait...</h2>
      </div>
    </div>
  );
};

Waiting.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
  fetch: state.fetch,
});

const mapDispatchToProps = {
  newCheckInAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Waiting);
